import React from "react";
import { Column, makeClassName, Row, StyleProps } from "@hex-insights/core";
import { BooleanFieldInputProps } from "@hex-insights/forms";
import { Icon } from "../../../../Components/Icon";
import styles from "./styles.module.css";

export type BooleanDetailedInputProps = BooleanFieldInputProps & {
	IconComponent: Icon.Icon;
	label: string;
	description: string;
} & Partial<StyleProps>;

export function BooleanDetailedInput({
	id,
	name,
	value,
	setValue,
	onFocus,
	onBlur,
	autoFocus,
	disabled,
	IconComponent,
	label,
	description,
	className,
	style,
}: BooleanDetailedInputProps) {
	const inputRef = React.useRef<HTMLInputElement | null>(null);

	const onChange = React.useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			setValue(event.target.checked);
		},
		[setValue],
	);

	const focusInput = React.useCallback(() => {
		if (inputRef.current !== null) {
			inputRef.current.focus();
		}
	}, []);

	return (
		<label
			className={makeClassName(
				styles["boolean-detailed-input"],
				value ? styles["boolean-detailed-input--checked"] : "",
				className,
			)}
			style={style}
		>
			<Column justify="spaced-start" verticalSpacing="1.5rem">
				<Row justify="space-between">
					<IconComponent size={32} className={styles["icon"]} />

					<input
						type="checkbox"
						ref={inputRef}
						id={id ?? name}
						name={name}
						checked={value}
						onChange={onChange}
						onClick={focusInput}
						onFocus={onFocus}
						onBlur={onBlur}
						autoFocus={autoFocus}
						disabled={disabled}
					/>
				</Row>

				<Column justify="spaced-start" verticalSpacing="0.5rem">
					<span className={styles["label"]}>{label}</span>
					<span className={styles["description"]}>{description}</span>
				</Column>
			</Column>
		</label>
	);
}
